export enum BenefitModeEnum {
    NotApplicable = 1,
    Monthly = 4,
    Annually = 5,
    Weekly = 12,
    Percentage = 16,
    AnnualLumpSum = 17,
}
